import { actionTypes } from 'app/constants/AnalyticsGa4Constants';

const setSdkConfig = ({ productId, productVersion }) => {
  return {
    type: actionTypes.SET_SDK_CONFIG,
    payload: { isSdk: true, productId, productVersion }
  };
};

const setSdkPageConfig = ({ contentGroup }) => {
  return {
    type: actionTypes.SET_SDK_PAGE_CONFIG,
    payload: { contentGroup, isSdk: true }
  };
};

const trackSdkCheckoutConsumeAccess = bib => {
  return {
    type: actionTypes.TRACK_SDK_CHECKOUT_CONSUME_ACCESS,
    payload: {
      bib,
      isSdk: true
    }
  };
};

const trackSdkCheckoutPlace = bib => {
  return {
    type: actionTypes.TRACK_SDK_CHECKOUT_PLACE,
    payload: {
      bib,
      isSdk: true
    }
  };
};

const trackSdkHoldingsConsumeAccess = ({ bib, metadata, ui }) => {
  return {
    type: actionTypes.TRACK_SDK_HOLDINGS_CONSUME_ACCESS,
    payload: {
      bib,
      isSdk: true,
      metadata,
      ui
    }
  };
};

const trackSdkHoldingsView = bib => {
  return {
    type: actionTypes.TRACK_SDK_HOLDINGS_VIEW,
    payload: {
      bib,
      isSdk: true
    }
  };
};

const trackSdkHoldPlace = (bib, properties) => {
  return {
    type: actionTypes.TRACK_SDK_HOLD_PLACE,
    payload: {
      bib,
      isSdk: true,
      properties
    }
  };
};

const trackSdkLogin = user => {
  return {
    type: actionTypes.TRACK_SDK_LOG_IN,
    payload: {
      isSdk: true,
      user
    }
  };
};

const trackSdkUserAccountRegister = user => {
  return {
    type: actionTypes.TRACK_SDK_USER_ACCOUNT_REGISTER,
    payload: {
      isSdk: true,
      user
    }
  };
};

const trackSdkUserContentAdd = ({ list }) => {
  return {
    type: actionTypes.TRACK_SDK_USER_CONTENT_ADD,
    payload: {
      isSdk: true,
      list
    }
  };
};

const trackSdkUserContentModify = ({ list }) => {
  return {
    type: actionTypes.TRACK_SDK_USER_CONTENT_MODIFY,
    payload: {
      isSdk: true,
      list
    }
  };
};

const trackSdkUserEngageFollow = () => {
  return {
    type: actionTypes.TRACK_SDK_USER_ENGAGE_FOLLOW,
    payload: { isSdk: true }
  };
};

export {
  setSdkConfig,
  setSdkPageConfig,
  trackSdkCheckoutConsumeAccess,
  trackSdkCheckoutPlace,
  trackSdkHoldingsConsumeAccess,
  trackSdkHoldingsView,
  trackSdkHoldPlace,
  trackSdkLogin,
  trackSdkUserAccountRegister,
  trackSdkUserContentAdd,
  trackSdkUserContentModify,
  trackSdkUserEngageFollow
};
